// Uncomment the line below if you create a custom dictionary
import { localization } from "../localizationManager";

export var finnishStrings = {
  groupButton: "Erottele minulla",
  ungroupButton: "Poista erottele minulla",
  selectButton: "Valitse minut",
  hideColumn: "Piilota sarake",
  showColumn: "Näytä sarake",
  makePrivateColumn: "Merkitse sarake yksityiseksi",
  makePublicColumn: "Merkitse sarake julkiseksi",
  moveToDetail: "Siirrä yksityiskohtiin",
  showAsColumn: "Näytä sarakkeena",
  filterPlaceholder: "Etsi...",
  removeRows: "Poista rivejä",
  showLabel: "Näytä",
  entriesLabel: "vastauksia",
  visualizer_text: "Tekstitaulukko",
  visualizer_wordcloud: "Sanapilvi",
  visualizer_histogram: "Histogrammi",
  visualizer_number: "Keskiarvo",
  visualizer_choices: "Taulukko",
  visualizer_selectBase: "Kuvaaja",
  visualizer_matrix: "Kuvaaja",
  chartType_bar: "Pylväs",
  chartType_vbar: "Vaakapyöväs",
  chartType_stackedbar: "Pinottu pylväs",
  chartType_doughnut: "Donitsi",
  chartType_pie: "Piirakka",
  chartType_scatter: "Hajonta",
  chartType_gauge: "Mittari",
  chartType_bullet: "Luoti",
  chartType_line: "Viiva",
  hideButton: "Piilota",
  makePrivateButton: "Merkise yksityiseksi",
  makePublicButton: "Merkitse julkiseksi",
  showButton: "Näytä",
  filter: "Rajaa",
  resetFilter: "Nollaa Rajaus",
  changeLocale: "Vaihda kieli",
  clearButton: "Nollaa",
  addElement: "Valitse näytettävä kysymys...",
  defaultOrder: "Oletusjärjestys",
  ascOrder: "Nouseva",
  descOrder: "Laskeva",
  showMinorColumns: "Näytä alasarakkeet",
  otherCommentTitle: "Muut asiat ja kommentit",
  showPercentages: "Näytä prosentit",
  hidePercentages: "Piilota prosentit",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Lataa kuvaaja PNG kuvana",
  hideEmptyAnswers: "Piilota tyhjät vastaukset",
  showEmptyAnswers: "Näytä tyhjät vastaukset",
  "topNValueText-1": "Kaikki vastaukset",
  "topNValueText5": "Top 5 vastaukset",
  "topNValueText10": "Top 10 vastaukset",
  "topNValueText20": "Top 20 vastaukset",
  hideMissingAnswers: "Piilota puuttuvat vastaukset",
  showMissingAnswers: "Näytä puuttuvat vastaukset",
  missingAnswersLabel: "Puuttuvat vastaukset",
  noVisualizerForQuestion: "Tätä kysymystyyppiä ei voida visualisoida.",
  noResults: "Ei vielä tuloksia",
  showPerValues: "Näytä arvottain",
  showPerColumns: "Näytä sarakkeittain",
  answer: "Vastaus",
  correctAnswer: "Oikea vastaus: ",
  percent: "Prosentti",
  percentage: "Prosenttiyksikkö",
  statistics_chart: "Kuvaaja",
  responses: "Vastaukset",
  visualizer_nps: "NPS",
  npsScore: "NPS",
  npsPromoters: "Suosittelija",
  npsPassives: "Passiivinen",
  npsDetractors: "Arvostelija",
};

// Uncomment the lines below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `englishStrings` with the name of the variable that contains the custom dictionary.
localization.locales["fi"] = finnishStrings;
localization.localeNames["fi"] = "Suomi";